import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { Select } from 'antd';

export interface IOrderStateSelectProps extends RouteComponentProps<{ eshop: string }> {
  name: string;
  onChange: (e: any, orderState: GQL.IExternalOrderState | undefined) => void;
  value: string | undefined | null;
  orderStates?: Array<GQL.IExternalOrderState>;
  style?: any;
}

class OrderStateSelect extends React.PureComponent<IOrderStateSelectProps> {

  constructor(props: IOrderStateSelectProps) {
    super(props);

    this.onChange = this.onChange.bind(this);
  }

  public render() {
    const { value, style, orderStates } = this.props;

    if (orderStates) {
      return (
        <Select
          placeholder={'Choose order state'}
          onChange={this.onChange}
          value={value ? value : ''}
          style={...style}
        >
          {orderStates.map(l => {
            return (
              <Select.Option key={l.id} value={l.id}>
                {l.title}
              </Select.Option>
            );
          })}
        </Select>
      );
    }

    return (
      <Select placeholder={'Choose order state'} style={...style} />
    );
  }

  private onChange(value: string) {
    const { orderStates } = this.props;

    const orderState = orderStates && orderStates.find((o: GQL.IExternalOrderState) => o.id === value);

    if (this.props.onChange) {
      this.props.onChange({
        target: {
          name: this.props.name,
          value,
        }
      }, orderState);
    }
  }
}

export { OrderStateSelect };



// WEBPACK FOOTER //
// ./src/components/Others/OrderStateSelect/OrderStateSelect.tsx